import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery } from '../../../hoc/withGraphql';
import getBusinessAnalytics from './getBusinessAnalytics.graphql';

const RED = '#D32F2F';
const TEAL = '#0E9488';
const INK = '#1F2733';

class Analytics extends Component {
  constructor(props) {
    super(props);
    this.state = { fromDate: '', toDate: '' };
  }

  data = () => (this.props.analytics && this.props.analytics.getBusinessAnalytics) || null;

  apply = () => {
    this.props.analytics.refetch({
      fromDate: this.state.fromDate || undefined,
      toDate: this.state.toDate || undefined,
    });
  };

  exportCsv = () => {
    const d = this.data();
    if (!d || !d.daily) return;
    const rows = [['Date', 'Bookings', 'GMV', 'Revenue']]
      .concat(d.daily.map((x) => [x.date, x.bookings, x.gmv, x.revenue]));
    const csv = rows.map((r) => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `besthand-analytics-${d.fromDate}_to_${d.toDate}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  render() {
    const d = this.data();
    const loading = this.props.analytics && this.props.analytics.loading;
    const t = (d && d.totals) || {};
    const cur = t.currency || 'USD';
    const sign = cur === 'USD' ? '$' : '';

    const input = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginRight: 8 };
    const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', marginRight: 8 });
    const kpi = (label, value, color) => (
      <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: '14px 18px', minWidth: 150 }}>
        <div style={{ fontSize: 24, fontWeight: 800, color: color || INK }}>{value}</div>
        <div style={{ fontSize: 12, color: '#666' }}>{label}</div>
      </div>
    );
    const th = { padding: 10, textAlign: 'left' };
    const td = { padding: 10, borderTop: '1px solid #f0f0f0' };

    const daily = (d && d.daily) || [];
    const cats = (d && d.topCategories) || [];

    return (
      <div style={{ fontFamily: 'Poppins, sans-serif' }}>
        <h1 className="siteAdminPrimaryHeading">Reports &amp; Analytics</h1>

        {/* Date range */}
        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 16 }}>
          <label style={{ fontSize: 13, color: '#666', marginRight: 6 }}>From</label>
          <input type="date" style={input} value={this.state.fromDate} onChange={(e) => this.setState({ fromDate: e.target.value })} />
          <label style={{ fontSize: 13, color: '#666', marginRight: 6 }}>To</label>
          <input type="date" style={input} value={this.state.toDate} onChange={(e) => this.setState({ toDate: e.target.value })} />
          <button style={btn(RED)} onClick={this.apply}>Apply</button>
          <button style={btn(TEAL)} onClick={this.exportCsv}>Export CSV</button>
          <span style={{ marginLeft: 8, fontSize: 13, color: '#888' }}>
            {d ? `${d.fromDate} → ${d.toDate}` : ''} {loading ? ' · loading…' : ''}
          </span>
        </div>

        {/* KPI cards */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, marginBottom: 20 }}>
          {kpi('GMV (volume d\'affaires)', `${sign}${t.gmv != null ? t.gmv : '—'}`, RED)}
          {kpi('Revenue (commissions)', `${sign}${t.revenue != null ? t.revenue : '—'}`, TEAL)}
          {kpi('Take rate', `${t.takeRate != null ? t.takeRate : '—'}%`)}
          {kpi('Bookings', t.bookings != null ? t.bookings : '—')}
          {kpi('Avg order value', `${sign}${t.avgOrderValue != null ? t.avgOrderValue : '—'}`)}
          {kpi('Cancel rate', `${t.cancelRate != null ? t.cancelRate : '—'}%`)}
          {kpi('New customers', t.newUsers != null ? t.newUsers : '—')}
          {kpi('New providers', t.newProviders != null ? t.newProviders : '—')}
        </div>

        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          {/* Daily */}
          <div style={{ flex: '2 1 420px', background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ padding: '10px 14px', fontWeight: 700, borderBottom: '1px solid #f0f0f0' }}>Daily breakdown</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead><tr style={{ background: '#fafafa' }}><th style={th}>Date</th><th style={th}>Bookings</th><th style={th}>GMV</th><th style={th}>Revenue</th></tr></thead>
              <tbody>
                {daily.length === 0 && <tr><td style={td} colSpan={4}>No data in this range.</td></tr>}
                {daily.map((x) => (
                  <tr key={x.date}><td style={td}>{x.date}</td><td style={td}>{x.bookings}</td><td style={td}>{sign}{x.gmv}</td><td style={td}>{sign}{x.revenue}</td></tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Top categories */}
          <div style={{ flex: '1 1 280px', background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ padding: '10px 14px', fontWeight: 700, borderBottom: '1px solid #f0f0f0' }}>Top categories</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead><tr style={{ background: '#fafafa' }}><th style={th}>Category</th><th style={th}>Bookings</th><th style={th}>GMV</th></tr></thead>
              <tbody>
                {cats.length === 0 && <tr><td style={td} colSpan={3}>No data.</td></tr>}
                {cats.map((c, i) => (
                  <tr key={i}><td style={td}>{c.name}</td><td style={td}>{c.bookings}</td><td style={td}>{sign}{c.gmv}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withQuery(getBusinessAnalytics, { name: 'analytics', options: { fetchPolicy: 'network-only', ssr: false } }),
)(Analytics);
